import { initialsFor } from './initials';

// Muted WhatsApp-like palette; white initials stay readable on all of these.
const PALETTE = ['#B8860B', '#3A8FB7', '#7F66FF', '#E26AB6', '#D9A21B', '#FF7A63', '#6B8E9F', '#4F7F5E'];

/** Stable palette colour for a phone number (hash of its digits). */
export const avatarColorFor = (phone) => {
  const digits = String(phone || '').replace(/\D/g, '');
  let hash = 0;
  for (const ch of digits) hash = (hash * 31 + Number(ch) + 1) % 100003;
  return PALETTE[hash % PALETTE.length];
};

const SIZES = { sm: 'h-9 w-9 text-sm', md: 'h-10 w-10 text-sm' };

/**
 * Initials on a colour that is stable per phone. The Cloud API gives no profile photos.
 * @param {{name?: string | null, phone: string, size?: 'sm' | 'md'}} props
 */
const ContactAvatar = ({ name, phone, size = 'md' }) => (
  <span
    data-testid="contact-avatar"
    style={{ backgroundColor: avatarColorFor(phone) }}
    className={`flex shrink-0 items-center justify-center rounded-full font-medium text-white ${SIZES[size] || SIZES.md}`}
  >
    {initialsFor(name, phone)}
  </span>
);

export default ContactAvatar;
